// ⚠️ GÉNÉRÉ par scripts/sync-config.mjs — NE PAS ÉDITER À LA MAIN.
// Source : data/config.json
window.VALMA_DATA = {
  "basePrice": 15900,
  "render": {
    "breloqueRatio": 2.5,
    "overlap": 0.13,
    "canvasHeightFactor": 1.3,
    "background": "#ffffff"
  },
  "tailles": [
    {
      "id": "jumbo",
      "label": "Jumbo",
      "mm": 10,
      "priceDelta": 0
    },
    {
      "id": "bigjumbo",
      "label": "Big Jumbo",
      "mm": 12,
      "priceDelta": 1000
    }
  ],
  "couleurs": [
    {
      "id": "q",
      "label": "Quartz rose",
      "hex": "#F4CCD4",
      "energie": "Réconfort, apaisement, paix, amitié, douceur intérieure."
    },
    {
      "id": "t",
      "label": "Turquoise",
      "hex": "#6FC9D6",
      "energie": "Protection puissante, purification, clarté mentale, régulation, pensées positives."
    },
    {
      "id": "r",
      "label": "Jade rouge",
      "hex": "#D81E16",
      "energie": "Protection, force, vitalité, ancrage, énergie."
    },
    {
      "id": "j",
      "label": "Jade verte",
      "hex": "#4A6A2F",
      "energie": "Aide aux relations saines, pierre revigorante, équilibre émotionnel."
    },
    {
      "id": "c",
      "label": "Calcite orange",
      "hex": "#F4C44C",
      "energie": "Réparatrice, apaisante, aide au sommeil, bien-être, dissipe les douleurs."
    },
    {
      "id": "b",
      "label": "Pierre de lune verte garniérite",
      "hex": "#AFD6B0",
      "energie": "Apaisement émotionnel, intuition, douceur intérieure, harmonie, régulation du stress."
    },
    {
      "id": "k",
      "label": "Crystal craquelé",
      "hex": "#E8E9EC",
      "energie": "Amplification des énergies, clarté mentale, purification, ouverture d'esprit, pensées positives."
    },
    {
      "id": "a",
      "label": "Agate blanche",
      "hex": "#F1EFEA",
      "energie": "Relaxation, stabilité, calme, migraines, tensions musculaires."
    }
  ],
  "breloques": [
    {
      "id": "bl1_roi_soleil",
      "label": "Le Roi Soleil",
      "priceDelta": 0,
      "img": "breloque-bl1_roi_soleil.png",
      "thumb": "thumb-breloque-bl1_roi_soleil.png",
      "ratio": 1.7
    },
    {
      "id": "bl2_ex_voto",
      "label": "Ex-Voto",
      "priceDelta": 0,
      "img": "breloque-bl2_ex_voto.png",
      "thumb": "thumb-breloque-bl2_ex_voto.png",
      "ratio": 1.7
    },
    {
      "id": "bl3_mirage",
      "label": "Mirage",
      "priceDelta": 0,
      "img": "breloque-bl3_mirage.png",
      "thumb": "thumb-breloque-bl3_mirage.png",
      "ratio": 1.7
    },
    {
      "id": "bl4_big_fish",
      "label": "Big Fish",
      "priceDelta": 0,
      "img": "breloque-bl4_big_fish.png",
      "thumb": "thumb-breloque-bl4_big_fish.png",
      "ratio": 1.7
    },
    {
      "id": "bl5_oeil_cleo",
      "label": "L'Œil de Cléo",
      "priceDelta": 0,
      "img": "breloque-bl5_oeil_cleo.png",
      "thumb": "thumb-breloque-bl5_oeil_cleo.png",
      "ratio": 1.7
    },
    {
      "id": "bl6_pyramide",
      "label": "Pyramide",
      "priceDelta": 0,
      "img": "breloque-bl6_pyramide.png",
      "thumb": "thumb-breloque-bl6_pyramide.png",
      "ratio": 1.7
    },
    {
      "id": "bl7_smile_shine",
      "label": "Smile & Shine",
      "priceDelta": 0,
      "img": "breloque-bl7_smile_shine.png",
      "thumb": "thumb-breloque-bl7_smile_shine.png",
      "ratio": 1.7
    },
    {
      "id": "bl8_coeur_rose",
      "label": "Mon P'tit Cœur Rose",
      "priceDelta": 0,
      "img": "breloque-bl8_coeur_rose.png",
      "thumb": "thumb-breloque-bl8_coeur_rose.png",
      "ratio": 1.7
    },
    {
      "id": "bl9_coeur_blanc",
      "label": "Mon P'tit Cœur Blanc",
      "priceDelta": 0,
      "img": "breloque-bl9_coeur_blanc.png",
      "thumb": "thumb-breloque-bl9_coeur_blanc.png",
      "ratio": 1.7
    },
    {
      "id": "bl10_coeur_orange",
      "label": "Mon P'tit Cœur Orange",
      "priceDelta": 0,
      "img": "breloque-bl10_coeur_orange.png",
      "thumb": "thumb-breloque-bl10_coeur_orange.png",
      "ratio": 1.7
    },
    {
      "id": "bl11_coeur_jaune",
      "label": "Mon P'tit Cœur Jaune",
      "priceDelta": 0,
      "img": "breloque-bl11_coeur_jaune.png",
      "thumb": "thumb-breloque-bl11_coeur_jaune.png",
      "ratio": 1.7
    },
    {
      "id": "bl12_sunny_orange",
      "label": "Sunny Orange",
      "priceDelta": 0,
      "img": "breloque-bl12_sunny_orange.png",
      "thumb": "thumb-breloque-bl12_sunny_orange.png",
      "ratio": 1.7
    },
    {
      "id": "bl13_sunny_rose",
      "label": "Sunny Rose",
      "priceDelta": 0,
      "img": "breloque-bl13_sunny_rose.png",
      "thumb": "thumb-breloque-bl13_sunny_rose.png",
      "ratio": 1.7
    },
    {
      "id": "bl14_sunny_jaune",
      "label": "Sunny Jaune",
      "priceDelta": 0,
      "img": "breloque-bl14_sunny_jaune.png",
      "thumb": "thumb-breloque-bl14_sunny_jaune.png",
      "ratio": 1.7
    },
    {
      "id": "bl15_sunny_blanc",
      "label": "Sunny Blanc",
      "priceDelta": 0,
      "img": "breloque-bl15_sunny_blanc.png",
      "thumb": "thumb-breloque-bl15_sunny_blanc.png",
      "ratio": 1.7
    },
    {
      "id": "bl16_medaillon_soleil",
      "label": "Médaillon Soleil",
      "priceDelta": 0,
      "img": "breloque-bl16_medaillon_soleil.png",
      "thumb": "thumb-breloque-bl16_medaillon_soleil.png",
      "ratio": 1.35
    },
    {
      "id": "bl17_petit_poisson",
      "label": "Petit Poisson",
      "priceDelta": 0,
      "img": "breloque-bl17_petit_poisson.png",
      "thumb": "thumb-breloque-bl17_petit_poisson.png",
      "ratio": 1.35
    },
    {
      "id": "bl18_coeur_etoile",
      "label": "Cœur Étoilé",
      "priceDelta": 0,
      "img": "breloque-bl18_coeur_etoile.png",
      "thumb": "thumb-breloque-bl18_coeur_etoile.png",
      "ratio": 1.7
    }
  ],
  "colliers": {
    "jumbo-q": {
      "img": "collier-jumbo-q.png",
      "cx": 0.52933,
      "yb": 0.942,
      "rw": 0.132
    },
    "jumbo-t": {
      "img": "collier-jumbo-t.png",
      "cx": 0.51933,
      "yb": 0.94067,
      "rw": 0.144
    },
    "jumbo-r": {
      "img": "collier-jumbo-r.png",
      "cx": 0.524,
      "yb": 0.94133,
      "rw": 0.13867
    },
    "jumbo-j": {
      "img": "collier-jumbo-j.png",
      "cx": 0.52267,
      "yb": 0.944,
      "rw": 0.144
    },
    "jumbo-c": {
      "img": "collier-jumbo-c.png",
      "cx": 0.52,
      "yb": 0.942,
      "rw": 0.13867
    },
    "jumbo-b": {
      "img": "collier-jumbo-b.png",
      "cx": 0.52133,
      "yb": 0.93933,
      "rw": 0.14267
    },
    "jumbo-k": {
      "img": "collier-jumbo-k.png",
      "cx": 0.52533,
      "yb": 0.92333,
      "rw": 0.144
    },
    "jumbo-a": {
      "img": "collier-jumbo-a.png",
      "cx": 0.52256,
      "yb": 0.94007,
      "rw": 0.14949
    },
    "bigjumbo-q": {
      "img": "collier-bigjumbo-q.png",
      "cx": 0.53333,
      "yb": 0.94467,
      "rw": 0.15733
    },
    "bigjumbo-t": {
      "img": "collier-bigjumbo-t.png",
      "cx": 0.53467,
      "yb": 0.96,
      "rw": 0.15067
    },
    "bigjumbo-r": {
      "img": "collier-bigjumbo-r.png",
      "cx": 0.53467,
      "yb": 0.964,
      "rw": 0.152
    },
    "bigjumbo-j": {
      "img": "collier-bigjumbo-j.png",
      "cx": 0.528,
      "yb": 0.95333,
      "rw": 0.15067
    },
    "bigjumbo-c": {
      "img": "collier-bigjumbo-c.png",
      "cx": 0.522,
      "yb": 0.95,
      "rw": 0.16133
    },
    "bigjumbo-b": {
      "img": "collier-bigjumbo-b.png",
      "cx": 0.526,
      "yb": 0.94267,
      "rw": 0.15733
    },
    "bigjumbo-k": {
      "img": "collier-bigjumbo-k.png",
      "cx": 0.53133,
      "yb": 0.94733,
      "rw": 0.164
    },
    "bigjumbo-a": {
      "img": "collier-bigjumbo-a.png",
      "cx": 0.526,
      "yb": 0.94,
      "rw": 0.15067
    }
  }
};